import React from 'react';
import { Flex, Text, Link } from '@chakra-ui/react';
import { useOrder, useOrderId } from '@olo-web/domain/orders/queries/useOrder';
import { useSavedDineInContextState } from '@olo-web/client-state';
import { useMerchantPath } from '@domain/merchants/hooks/useMerchantPath';
import { ContentCard } from '@olo-web/components/atoms/ContentCard';
import { ApplyOffersButton } from '../ApplyOffersButton/ApplyOffersButton';
import { GuestTotalsList } from './GuestTotalsList.ui';
import { useIsSplitByAmount } from '@olo-web/utils/common/hooks/useIsSplitByAmount';
import { useOrderType } from '@olo-web/utils/common/hooks';
import { ECheckoutTypes } from '@olo-web/types/enums';
import { useOrderIdFeatureFlagEnabled } from '@olo-web/utils/common/hooks/useOrderIdFeatureFlagEnabled';

export const GuestTotals = () => {
  const { data: order } = useOrder();
  const orderId = useOrderId();
  const path = useMerchantPath();
  const savedDineinContext = useSavedDineInContextState();
  const isSplitByAmount = useIsSplitByAmount();
  const orderType = useOrderType();
  const orderIdFFEnabled = useOrderIdFeatureFlagEnabled();

  return (
    <ContentCard
      title="Guest totals"
      headerContainerFlexProps={{ alignItems: 'end' }}
      titleDescriptionFlexProps={{ margin: 0 }}
      rightTitleAdornment={
        global.navigator?.share && (
          <Link
            style={{ textDecoration: 'underline', alignSelf: 'center' }}
            fontSize="sm"
            color="primary.350"
            href="#"
            onClick={() => {
              global.navigator?.share({
                title: 'Split by amount',
                url: `${path}/checkout?checkoutType=${
                  ECheckoutTypes.SPLIT_BY_AMOUNT
                }&orderType=${orderType}&${
                  orderIdFFEnabled
                    ? `orderId=${order?.id || orderId}`
                    : `tableNum=${savedDineinContext?.table?.number}`
                }`,
              });
            }}
          >
            Share link
          </Link>
        )
      }
      data-testid="guest-totals-section"
    >
      <Text fontSize="sm" mt={-1} mb={1}>
        Select the guest(s) you would like to pay for.
      </Text>
      <Flex direction="column" justifyContent="flex-start">
        <GuestTotalsList guests={order?.guests} showCheckBox showPaid fadeIfPaid />
        <Text fontStyle="italic" fontSize="xs" opacity={0.55}>
          Sales tax and fees are included in guest totals
        </Text>
      </Flex>
      {!isSplitByAmount && <ApplyOffersButton marginTop="16px !important" />}
    </ContentCard>
  );
};
